import { NgModule } from '@angular/core';

import { CCCVCDirective } from './directives/cc-cvc.directive'
import { CCExpirationDirective } from './directives/cc-exp.directive'
import { CCNumberDirective } from './directives/cc-number.directive'

import { UHEqualityDirective } from './directives/uh-equality.directive'

@NgModule({
  declarations: [
    CCCVCDirective,
    CCExpirationDirective,
    CCNumberDirective,
    UHEqualityDirective,
  ],
  exports: [
    CCCVCDirective,
    CCExpirationDirective,
    CCNumberDirective,
    UHEqualityDirective,
  ]
})
export class PaymentModule { }
